var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 353,
    viewBox: "0 0 509 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412.177 86.2214C407.845 37.8872 367.593 -9.73938e-06 318.56 -9.73938e-06C293.091 -9.73938e-06 269.993 10.2313 253.072 26.8327C236.132 10.2313 213.053 -9.73938e-06 187.585 -9.73938e-06C139.154 -9.73938e-06 99.2901 36.9464 94.142 84.4182C41.7675 86.5938 4.87615e-05 130.067 4.87615e-05 183.419C4.87615e-05 236.771 43.9822 282.537 98.2411 282.537C98.9404 282.537 99.6204 282.498 100.3 282.478C114.19 317.367 148.012 342.004 187.565 342.004C210.178 342.004 230.926 333.949 247.147 320.522C264.379 340.417 289.711 353 317.957 353C360.871 353 397.044 323.992 408.311 284.36C409.127 284.38 409.943 284.419 410.759 284.419C465.018 284.419 509 240.044 509 185.301C509 130.557 465.776 86.9858 412.197 86.2214H412.177Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.739645c1e3bd0fc5995d008707b97866.svg";
export { ForwardRef as ReactComponent };